import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@bufferapp/components';
import { Warning } from '@bufferapp/ui/Icon';
import { white } from '@bufferapp/ui/style/colors';
import { IconWrapper, PostPendingBannerWrapper } from './style';

const PostPendingBanner = ({ serviceName }) => (
  <PostPendingBannerWrapper>
    <IconWrapper>
      <Warning color={white} />
    </IconWrapper>
    <Text size="mini" weight="medium" color="white">
      {serviceName} is processing this post
    </Text>
  </PostPendingBannerWrapper>
);

PostPendingBanner.propTypes = {
  serviceName: PropTypes.string.isRequired,
};

export default PostPendingBanner;
